<template lang="pug">
section
  s-page-title(title='Истории успеха')
    template(slot='extension')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
        template(slot='controls')
          
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.name }}
          td {{ props.item.comment }}
          td {{ props.item.published_at }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='job/stories'
            )
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Название / Имя',
        align: 'left',
        value: 'name',
        width: '100%',
        sortable: true
      },
      {
        text: 'Комментарий / Должность',
        align: 'left',
        value: 'comment',
        width: '0%',
        sortable: true
      },
      {
        text: 'Дата публикации',
        align: 'left',
        value: 'published_at',
        width: '0%',
        sortable: true
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ]
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Job.Stories.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    async onDelete({ id }) {
      if (!(await this.$confirm('Вы уверены?'))) return

      try {
        await this.destroy({ id })
      } catch (e) {
        this.$root.showSnack('Ошибка удаления')
      }

      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('job/stories', ['fetchList', 'destroy']),
    ...mapMutations('job/stories', ['setDataFilter'])
  },

  computed: {
    ...mapState('job/stories', ['total', 'dataFilter']),
    ...mapGetters('job/stories', ['list', 'isLoading'])
  }
}
</script>
